'use strict';
module.exports = typeof setImmediate === 'function' ? setImmediate :
	function setImmediate() {
		var args = [].slice.apply(arguments);
		args.splice(1, 0, 0);
		setTimeout.apply(null, args);
	};



//////////////////
// WEBPACK FOOTER
// ./~/set-immediate-shim/index.js
// module id = 1854
// module chunks = 0